import { useEffect } from 'react';

/**
 * Injects a JSON-LD <script> tag into <head> for structured data (SEO rich results).
 * Each instance is keyed by `id` so updates replace rather than duplicate.
 */
export function JsonLd({ id, data }) {
  useEffect(() => {
    if (!data) return undefined;
    const scriptId = `jsonld-${id}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const existing = document.getElementById(scriptId);
      if (existing) existing.remove();
    };
  }, [id, data]);
  return null;
}

export default JsonLd;
